import NewsService from '../services/News.service';
import { addUnique } from 'utils/kentico-utils';

import { observable } from 'mobx';

const FEATURED_NEWS_LIMIT = 10;
const LATEST_NEWS_LIMIT = 10;

class NewsStore {
  initHomepageFetch = observable.box(false);

  latestNewsSettings = {
    historyStateKey: null,
    criteria: {},
    pagination: {},
    endOfCollection: false
  };
  // Latest Case Studies
  // Object for storing latest case studies, controls the pagination for the case study list view
  latestNews = [
    {
      criteria: {
        publishYear: ''
      },
      items: [],
      endOfCollection: false
    }
  ];

  // Featured Case Studies
  featuredNews = [];
  news = {};

  /**
   * Fetch featured Case Studies
   * @param { object } options
   *    { number } limit (optional) limit of items in response
   *
   * @returns { News[] } Prommise resolved to array of Case Study
   */
  async fetchFeaturedNews({ limit = FEATURED_NEWS_LIMIT } = {}) {
    if (this.featuredNews.length > 0) {
      return this.featuredNews;
    }

    try {
      const items = await NewsService.fetchNews({
        limit,
        page: 1,
        featured: true
      });
      if (!items.isEmpty) {
        this.featuredNews = items.items;
      }
    } catch (e) {
      console.error('Failed to fetch featured case studies data', e);
      return [];
    }
    return this.featuredNews;
  }

  async fetchLatestNews(criteria, pagination, initHomepageFetch = false) {
    const { skip = 0, limit = LATEST_NEWS_LIMIT } = pagination;

    if (initHomepageFetch) {
      this.initHomepageFetch.set(true);
    }

    const getQueriedCollection = criteria => {
      const collection = this.latestNews.find(
        c => c.criteria.publishYear === criteria.publishYear // define here the criteria comparision
      );
      if (!collection) {
        const newCollection = {
          criteria: { ...criteria },
          items: [],
          endOfCollection: false
        };
        this.latestNews.push(newCollection);
        return newCollection;
      }
      return collection;
    };

    const queriedCollection = getQueriedCollection(criteria);

    //has it in cache, return it
    if (queriedCollection.items.length >= skip + limit) {
      return {
        items: queriedCollection.items.slice(skip, skip + limit),
        endOfCollection: false
      };
    } else if (queriedCollection.endOfCollection) {
      return {
        items: queriedCollection.items.slice(
          skip,
          queriedCollection.items.length
        ),
        endOfCollection: true
      };
    }

    // has to fetch it
    const itemsToFetch = queriedCollection.items.length + limit - skip;

    try {
      const items = await NewsService.fetchNews({
        limit: itemsToFetch,
        skip: skip,
        ...criteria
      });
      queriedCollection.endOfCollection = !items.pagination.nextPage;
      addUnique(queriedCollection.items, items.items);

      return {
        items: items.items,
        endOfCollection: queriedCollection.endOfCollection
      };
    } catch (e) {
      console.error('Failed to fetch news', e);
      return {
        items: [],
        endOfCollection: true
      };
    }
  }

  /**
   * Get News by id
   * @param { string } id
   * @returns { News } Promise resolved News
   */

  async getNewsById(id) {
    try {
      const items = await NewsService.getNewsById(id);

      if (items.isEmpty) {
        return null;
      }
      if (items.items.length > 1) {
        throw new DOMException(
          'getById method should have returned only one item'
        );
      }
      this.news = items.items[0];
    } catch (e) {
      console.error('Failed to fetch case study data', e);
      return null;
    }

    return this.news;
  }

  async getNewsBySlug(slug, lang) {
    try {
      const items = await NewsService.getNewsBySlug(slug, lang);
      if (items.isEmpty) {
        return null;
      }
      if (items.items.length > 1) {
        throw new DOMException(
          'getBySlug method should have returned only one item'
        );
      }
      this.news = items.items[0];
    } catch (e) {
      console.error('Failed to fetch news data', e);
      return null;
    }

    return this.news;
  }
}

export default new NewsStore();



// WEBPACK FOOTER //
// ./src/stores/News.store.js